<template>
  <div class="home">
      <Tab :tab-data="categoryList"
           :render-fun="renderFun">
      </Tab>
  </div>
</template>

<script>
import { apiOfficeGetCategoryList } from '@/api'
import Tab from '@/components/tab/Tab'
import Category from '@/views/home/Category'
export default {
  name: 'Home',
  components: {
    Tab
  },
  data () {
    return {
      categoryList: []
    }
  },
  created () {
    apiOfficeGetCategoryList().then((response) => {
      const { list } = response
      this.categoryList = list
    })
  },
  methods: {
    // eslint-disable-next-line consistent-return
    renderFun (h, categoryData, index) {
      if (categoryData) {
        return h(Category, {
          props: {
            categoryData,
            index,
          },
          class: 'home-category'
        })
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/style/styleVariable";
@import "../../assets/style/styleMixins";
.home{
  &-category{
    max-width: @max_page_width;
    min-width: @min_page_width;
  }
}
</style>
